import React from "react";
import { capitalizeFirstLetter, getCurrencySymbol } from "../../../../Utils";
import classes from "./SourceRefundsList.module.scss";

const refundLabels = {
  cc: "CC",
  cash: "Cash",
  check: "Check",
  "gift card": "Gift Card",
  wallet: "Wallet",
  care_credit: "CareCredit",
  greensky: "GreenSky",
  instant_bank_payment: "Instant Bank Payment",
};

const SourceRefundsList = ({ refundOptions, refundType }) => {
  return (
    <ul className={classes.refundsList}>
      {refundOptions.map((refund, index) => {
        const normalizedPaymentMode = refund.payment_mode.toLowerCase();
        const refundTo =
          refundLabels[normalizedPaymentMode] === "Gift Card"
            ? "Wallet"
            : refundLabels[normalizedPaymentMode] || refund.payment_mode;
        const formattedRefundTo = capitalizeFirstLetter(
          refundType === "default" ? refundTo : refundType,
        );

        return (
          <li key={index}>
            <p>
              {`${getCurrencySymbol()}${refund.total_amount}`}{" "}
              {capitalizeFirstLetter(
                refundLabels[refund.payment_mode] || refund.payment_mode,
              )}{" "}
              payment refunding to {formattedRefundTo}
            </p>
          </li>
        );
      })}
    </ul>
  );
};

export default SourceRefundsList;
